import React from 'react'
import NavBar from '../components/NavBar';
import TitleCard from '../components/TitleCard';
import Team from '../screens/Team';
import Footer from '../components/Footer';

const People = () => {
  return (
    <>
        <NavBar/>
        <TitleCard heading="Meet Our Team" subHeading="Passionate Experts Driving Animal Conservation Excellence"/>
        <Team />
        <Footer />
    </>
  )
}

export default People